import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="max-w-3xl mx-auto px-6 md:px-10 py-32 text-center">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[var(--text-muted)]">Page not found</p>
      <h1 className="mt-4 font-display text-7xl md:text-9xl font-light tracking-tighter">404.</h1>
      <p className="mt-4 text-[var(--text-muted)]">Looks like this page took a coffee break.</p>
      <Link to="/" data-testid="notfound-home-btn" className="mt-10 btn-primary">
        <ArrowLeft className="w-4 h-4" /> Back home
      </Link>
    </div>
  );
}
